
import { useState } from 'react';
import PageNavbar from '../../components/feature/PageNavbar';
import Footer from '../home/components/Footer';
import QuoteRequest from './components/QuoteRequest';
import ProductComparison from './components/ProductComparison';
import SavedItems from './components/SavedItems';
import ContactForm from './components/ContactForm';
import FAQ from './components/FAQ';

export default function BuyerToolsPage() {
  const [activeTab, setActiveTab] = useState<'quote' | 'compare' | 'saved' | 'contact' | 'faq'>('quote');

  const tabs = [
    { id: 'quote' as const, label: '견적 요청', icon: 'ri-file-list-3-line' },
    { id: 'compare' as const, label: '제품 비교', icon: 'ri-scales-line' },
    { id: 'saved' as const, label: '관심 목록', icon: 'ri-heart-line' },
    { id: 'contact' as const, label: '문의하기', icon: 'ri-message-3-line' },
    { id: 'faq' as const, label: 'FAQ', icon: 'ri-question-line' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <PageNavbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-teal-50 via-white to-cyan-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full text-teal-700 text-sm font-medium mb-6">
              <i className="ri-ship-line"></i>
              선장/선주 전용 서비스
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              편리한 구매 지원 도구
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              견적 요청부터 제품 비교까지, 선박 물품 구매에 필요한 모든 기능을 한 곳에서 이용하세요
            </p>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">24시간</div>
              <div className="text-sm text-gray-600">평균 견적 응답</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">150+</div>
              <div className="text-sm text-gray-600">제조업체 네트워크</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">98%</div>
              <div className="text-sm text-gray-600">고객 만족도</div>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 text-center">
              <div className="text-3xl font-bold text-teal-600 mb-2">무료</div>
              <div className="text-sm text-gray-600">모든 서비스</div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          {/* Tab Navigation */}
          <div className="flex flex-wrap gap-3 mb-12 justify-center">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-teal-600 text-white shadow-lg shadow-teal-600/30'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                <i className={tab.icon}></i>
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12">
            {activeTab === 'quote' && <QuoteRequest />}
            {activeTab === 'compare' && <ProductComparison />}
            {activeTab === 'saved' && <SavedItems />}
            {activeTab === 'contact' && <ContactForm />}
            {activeTab === 'faq' && <FAQ />}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            지금 바로 시작하세요
          </h2>
          <p className="text-xl text-teal-50 mb-10">
            전국의 우수한 제조업체와 직접 연결되어 최적의 조건으로 물품을 공급받으세요
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="/products"
              className="inline-flex items-center gap-2 px-8 py-4 bg-white text-teal-600 rounded-full font-semibold hover:shadow-xl transition-all whitespace-nowrap"
            >
              <i className="ri-search-line"></i>
              제품 둘러보기
            </a>
            <a
              href="/manufacturers"
              className="inline-flex items-center gap-2 px-8 py-4 bg-teal-700 text-white rounded-full font-semibold hover:bg-teal-800 transition-all whitespace-nowrap"
            >
              <i className="ri-building-line"></i>
              제조업체 찾기
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
